function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { sendTrackAnalytics } from './player.reducerHelpers';
import { getTrackIndex, sprigPlayEvent } from './utils';
var getRandomTrackIndex = function getRandomTrackIndex(currentIndex, queueLength) {
  if (queueLength <= 1) return 0;
  var nextIndex;
  do {
    nextIndex = Math.floor(Math.random() * queueLength);
  } while (nextIndex === currentIndex);
  return nextIndex;
};
var playTrack = function playTrack(track, playerState, action) {
  action.playNewTrack(track);
  sprigPlayEvent();
  var newPlayerHistory = playerState.playHistory;

  // Update session history if track hasn't been played
  if (!playerState.playHistory.includes(track.id)) {
    newPlayerHistory.push(track.id);
    action.setSessionHistory(newPlayerHistory);
  }
  sendTrackAnalytics(track);
  return _objectSpread(_objectSpread({}, playerState), {}, {
    currentTrack: track,
    isPlaying: true,
    playHistory: newPlayerHistory
  });
};
var playerReducer = function playerReducer(playerState, action) {
  switch (action.type) {
    case 'setCurrentTrack':
      {
        return _objectSpread(_objectSpread({}, playerState), {}, {
          currentTrack: action.track
        });
      }
    case 'initialPlay':
      {
        var _playerState$currentT;
        if (!(playerState !== null && playerState !== void 0 && playerState.currentTrack) || action.track.id !== (playerState === null || playerState === void 0 ? void 0 : (_playerState$currentT = playerState.currentTrack) === null || _playerState$currentT === void 0 ? void 0 : _playerState$currentT.id)) {
          action.playNewTrack(action.track);
          sprigPlayEvent();
          var newPlayerHistory = playerState.playHistory;

          // send trackId to session storage
          if (!playerState.playHistory.includes(action.track.id)) {
            newPlayerHistory.push(action.track.id);
            action.setSessionHistory(newPlayerHistory);
          }
          sendTrackAnalytics(action.track, action.analyticArgs);
          return _objectSpread(_objectSpread({}, playerState), {}, {
            isPlaying: true,
            playHistory: newPlayerHistory
          });
        }
        return playerState;
      }
    case 'stop':
      {
        return _objectSpread(_objectSpread({}, playerState), {}, {
          isPlaying: false
        });
      }
    case 'togglePlay':
      {
        var _playerState$currentT2;
        if (action.track.id === ((_playerState$currentT2 = playerState.currentTrack) === null || _playerState$currentT2 === void 0 ? void 0 : _playerState$currentT2.id)) {
          playerState.isPlaying ? action.pause() : action.play();
          return _objectSpread(_objectSpread({}, playerState), {}, {
            isPlaying: !playerState.isPlaying
          });
        }
        return playerState;
      }
    case 'simplePlay':
      {
        if (!playerState.currentTrack && playerState.queue) {
          var _playerState$playHist;
          var firstTrack = playerState.queue[0];
          action.playNewTrack(firstTrack);
          var _newPlayerHistory = playerState.playHistory;

          // send trackId to session storage
          if (playerState.playHistory && !((_playerState$playHist = playerState.playHistory) !== null && _playerState$playHist !== void 0 && _playerState$playHist.includes(firstTrack.id))) {
            _newPlayerHistory.push(firstTrack.id);
            action.setSessionHistory(_newPlayerHistory);
          }
          sprigPlayEvent();
          return _objectSpread(_objectSpread({}, playerState), {}, {
            isPlaying: !playerState.isPlaying,
            currentTrack: firstTrack
          });
        }
        playerState.isPlaying ? action.pause() : action.play();
        return _objectSpread(_objectSpread({}, playerState), {}, {
          isPlaying: !playerState.isPlaying
        });
      }
    case 'initialiseQueue':
      {
        return _objectSpread(_objectSpread({}, playerState), {}, {
          queue: action.tracks
        });
      }
    case 'playNextTrack':
      {
        var urlParams = new URLSearchParams(window.location.search);
        var isRandomEnabled = urlParams.has('random');
        var currentPlayingTrackIndex = getTrackIndex(playerState.currentTrack, playerState.queue);

        // Handle end of queue for sequential playback
        if (!isRandomEnabled && currentPlayingTrackIndex === playerState.queue.length - 1) {
          action.reset();
          return _objectSpread(_objectSpread({}, playerState), {}, {
            isPlaying: false
          });
        }

        // Get next track index
        var nextTrackIndex = isRandomEnabled ? getRandomTrackIndex(currentPlayingTrackIndex, playerState.queue.length) : currentPlayingTrackIndex + 1;
        var nextTrack = playerState.queue[nextTrackIndex];
        return playTrack(nextTrack, playerState, action);
      }
    case 'playPreviousTrack':
      {
        var _currentPlayingTrackIndex = getTrackIndex(playerState.currentTrack, playerState.queue);
        if (_currentPlayingTrackIndex === 0 || _currentPlayingTrackIndex === -1) {
          action.reset();
          return _objectSpread(_objectSpread({}, playerState), {}, {
            isPlaying: false
          });
        }
        var previousTrack = playerState.queue[_currentPlayingTrackIndex - 1];
        action.playNewTrack(previousTrack);
        sprigPlayEvent();
        var _newPlayerHistory2 = playerState.playHistory;

        // send trackId to session storage
        if (!playerState.playHistory.includes(previousTrack.id)) {
          _newPlayerHistory2.push(previousTrack.id);
          action.setSessionHistory(_newPlayerHistory2);
        }
        sendTrackAnalytics(previousTrack);
        return _objectSpread(_objectSpread({}, playerState), {}, {
          currentTrack: previousTrack,
          isPlaying: true,
          playHistory: _newPlayerHistory2
        });
      }
    case 'initialisePlayHistory':
      {
        return _objectSpread(_objectSpread({}, playerState), {}, {
          playHistory: action.sessionHistory
        });
      }
    case 'setCurrentTime':
      {
        return _objectSpread(_objectSpread({}, playerState), {}, {
          currentTime: action.currentTime
        });
      }
    default:
      {
        throw Error('unknown action');
      }
  }
};
export default playerReducer;